import { stackConstants } from '../_constants';

export const stackUtilities = {
  sort,
  filter,
  linksFromStacks,
  tagsForOrigami,
};

// The stack ids an origami is tagged with, resolved through the links table.
//
// An origami's origamiLinks.items and state.stack.links.byId are written by
// different actions and are not updated atomically. While a tag request is in
// flight the box side already holds the TAG_REQUEST placeholder id, but the
// stack side has no entry for it -- and the same gap opens briefly around
// deletes. Any id that does not resolve is skipped rather than dereferenced:
// the sidebar simply does not show that tag until the real link lands, which
// is what the pre-immutability code did by never re-rendering in between.
function tagsForOrigami(origami, linksById) {
  if (!origami || !origami.origamiLinks || !linksById) {
    return [];
  }
  const result = [];
  for (const linkId of origami.origamiLinks.items || []) {
    const link = linksById[linkId];
    if (link && link.stackId) {
      result.push(link.stackId);
    }
  }
  return result;
}

// Turns the links normalizr collected under entities.links while normalising
// the stacks into the { entities, result } shape the stack reducer stores as
// state.stack.links. normalizr omits an entity table it never wrote to, so a
// user with no tagged origamis gets an empty table rather than undefined.
function linksFromStacks(normalizedStacks) {
  const links =
    (normalizedStacks.entities && normalizedStacks.entities.links) || {};
  return { entities: { links }, result: Object.keys(links) };
}

// Returns dictionary of { origamiId: linkId } given tagId id, stackLinks byId / allIds
// Upgrading the id parameter to be string or array of ids
// Will overwrite linkId to last one if using id array input
function filter(id, object, array, param_src, param_dst) {
  if (Object.keys(object).length === 0) {
    return {};
  }
  const idArray = typeof id === 'string' ? [id] : id;

  // Create union of all tags in filtered tags
  const filtered = array.filter((i) => {
    if (!object.hasOwnProperty(i)) {
      console.log(i);
      return false;
    }
    if (!object[i].hasOwnProperty(param_src)) {
      console.log(i);
      return false;
    }
    return idArray.includes(object[i][param_src]);
  });

  // Compile dictionary of OGids with the respective tags
  const result = {};

  for (let i = 0; i < filtered.length; i++) {
    let key = object[filtered[i]][param_dst];
    let linkKey = object[filtered[i]]['id'];

    if (result.hasOwnProperty(key)) {
      result[key] = [...result[key], ...[linkKey]];
    } else {
      result[key] = [linkKey];
    }
  }

  // Filter result for only OGids that contain === filter tags
  const final = Object.assign(
    {},
    ...Object.keys(result).map((k) => {
      return result[k].length === idArray.length ? { [k]: result[k] } : null;
    })
  );

  return final;
}

function sort(sortBy, object, idArray, newItem) {
  const allIds = Array.from(idArray);

  if (newItem && newItem.id) {
    allIds.push(newItem.id);
    object[newItem.id] = newItem;
  }

  allIds.sort((idA, idB) => {
    const a = object[idA];
    const b = object[idB];
    switch (sortBy) {
      case stackConstants.SORT_NAME_ASC:
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return 1;
        }
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return -1;
        }
        return 0;
      case stackConstants.SORT_NAME_DESC:
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        return 0;
      case stackConstants.SORT_COUNT_ASC:
        if (a.origamiLinks.items.length < b.origamiLinks.items.length) {
          return -1;
        }
        if (a.origamiLinks.items.length > b.origamiLinks.items.length) {
          return 1;
        }
        return 0;
      case stackConstants.SORT_COUNT_DESC:
        if (a.origamiLinks.items.length < b.origamiLinks.items.length) {
          return 1;
        }
        if (a.origamiLinks.items.length > b.origamiLinks.items.length) {
          return -1;
        }
        return 0;
      default:
        return allIds;
    }
  });
  return allIds;
}
